import { EstimateService, QuotationService } from '@common/lib/api';
import * as estimate from './types';

const actions = {
  async [estimate.ESTIMATION_ALL_RESET_STATE](context) {
    context.commit(estimate.ESTIMATION_ALL_RESET_STATE);
  },

  async [estimate.ESTIMATION_LIST_RESET_STATE](context) {
    context.commit(estimate.ESTIMATION_LIST_RESET_STATE);
  },

  async [estimate.CREATE_ESTIMATION](context, params) {
    const { data } = await EstimateService.add(params);

    return data;
  },
  async [estimate.FETCH_ESTIMATION](context, params) {
    const { data } = await EstimateService.getById(params);
    context.commit(estimate.SET_ESTIMATION, data);

    return data;
  },
  async [estimate.UPDATE_ESTIMATION](context, payload) {
    const { data } = await EstimateService.modifyById(payload);

    return data;
  },
  async [estimate.DELETE_ESTIMATION](context, params) {
    const { data } = await EstimateService.removeById(params);

    return data;
  },
  async [estimate.FETCH_ESTIMATION_LIST](context, params) {
    const { data } = await EstimateService.getList(params);
    context.commit(estimate.SET_ESTIMATION_LIST, data);

    return data;
  },

  async [estimate.FETCH_AUTO_ESTIMATION_IN_PROGRESS](context, params) {
    const { data } = await EstimateService.getInProgressAutoEstimate(params);
    context.commit(estimate.SET_AUTO_ESTIMATION, data);

    return data;
  },
  [estimate.SET_AUTO_ESTIMATION](context, data) {
    context.commit(estimate.SET_AUTO_ESTIMATION, data);
  },
  async [estimate.FETCH_LATELY_ESTIMATION](context, params) {
    const { data } = await EstimateService.getLatelyEstimate(params);
    context.commit(estimate.SET_ESTIMATION, data);

    return data;
  },

  async [estimate.CREATE_QUOTATION](context, params) {
    const { data } = await QuotationService.add(params);
    context.commit(estimate.QUOTATION_RESET_STATE);
    return data;
  },
  async [estimate.FETCH_QUOTATION](context, params) {
    const { data } = await QuotationService.getById(params);
    context.commit(estimate.SET_QUOTATION, data);

    return data;
  },
  async [estimate.FETCH_QUOTATION_LIST](context, params) {
    const { data } = await QuotationService.getList(params);
    context.commit(estimate.SET_QUOTATION_LIST, data);

    return data;
  },
  async [estimate.PUSH_QUOTATION](context, params) {
    const { data } = await QuotationService.push(params);

    return data;
  },
  async [estimate.FETCH_QUOTATION_ME](context, params) {
    const { data } = await QuotationService.me(params);
    context.commit(estimate.SET_QUOTATION_LIST, data);
    return data;
  },

  [estimate.SET_QUOTATION](context, data) {
    context.commit(estimate.SET_QUOTATION, data);
  },

  [estimate.QUOTATION_RESET_STATE](context, data) {
    context.commit(estimate.QUOTATION_RESET_STATE, data);
  },
  [estimate.ESTIMATION_MODEL_RESET_STATE](context) {
    context.commit(estimate.ESTIMATION_MODEL_RESET_STATE);
  },
  [estimate.SET_ESTIMATION_MODEL](context, data) {
    context.commit(estimate.SET_ESTIMATION_MODEL, data);
  },
  [estimate.SET_ESTIMATION_REQUEST_AT](context, data) {
    context.commit(estimate.SET_ESTIMATION_REQUEST_AT, data);
  },
};

export default actions;
